/**
 * AdSense slot IDs.
 * Publisher: ca-pub-0647251616275542
 */
export const AD_SLOTS = {
  speedResult: "1104322000",      // Speed Test — below verdict/activities
  landingMid: "9721178627",       // Landing — between hero and tools grid
  downDetectorMid: "5781933610",  // Down Detector — below service grid
  myIpBottom: "9576566759",       // My IP — bottom of details
  fixMid: "6151280887",           // Fix My Internet — bottom
  landingFeed: "5057691069",      // Landing — below news feed
};

// Maps the logical "name" passed to <AdSlot name=...> to a human label + slot id.
// This drives the full-coverage leaderboard in the Admin screen.
export const AD_SLOT_CATALOG = [
  { name: "speed-result",     label: "Speed Test — below result", slotId: AD_SLOTS.speedResult },
  { name: "landing-mid",      label: "Landing — hero · tools",    slotId: AD_SLOTS.landingMid },
  { name: "down-detector-mid",label: "Down Detector — mid",       slotId: AD_SLOTS.downDetectorMid },
  { name: "my-ip-bottom",     label: "My IP — bottom",            slotId: AD_SLOTS.myIpBottom },
  { name: "fix-mid",          label: "Fix My Internet — bottom",  slotId: AD_SLOTS.fixMid },
  { name: "landing-feed",     label: "Landing — below news feed", slotId: AD_SLOTS.landingFeed },
];
